import {
	Button,
	FormControl,
	HStack,
	Icon,
	IconButton,
	Text,
	Modal,
	ModalBody,
	ModalOverlay,
	ModalCloseButton,
	ModalHeader,
	ModalContent,
	useDisclosure,
	Tooltip,
	Box,
	Flex,
	DrawerContent,
	Drawer,
	DrawerOverlay,
	DrawerCloseButton,
	DrawerHeader,
	DrawerBody,
	VStack,
	List,
	ListItem,
	Center,
	Divider,
	Badge,
} from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { ImAttachment } from 'react-icons/im'
import { BsFillFileEarmarkLockFill } from 'react-icons/bs'
import { IoIosSend, IoMdClose, IoMdCheckmark } from 'react-icons/io'
import {
	MdFilterList,
	MdPersonAdd,
	MdPersonOutline,
	MdMoreVert,
	MdFilePresent,
} from 'react-icons/md'
import { BiMailSend, BiSend } from 'react-icons/bi'
import { Mention, MentionsInput } from 'react-mentions'

import CustomMenu from '../../../../../components/menu'
import { useAuthContext } from '../../../../../context/auth.context'
import { useSharedContext } from '../../../../../context/shared.context'
import {
	useAddTimelineUpdate,
	useInviteParticipant,
} from '../../../../../hooks/activity.hooks'
import {
	sanitizeContent,
	validateEmailUsernamePassword,
} from '../../../../../utils/common.util'
import {
	formatNoteUpdateDate,
	getCurrentDateUTC,
} from '../../../../../utils/date.utils'
import { sharedConst } from '../../../../../utils/action.constant'
import { timelineOptions } from '../../../../../components/timeline/util'
import KeyboardEventHandler from 'react-keyboard-event-handler'
import { useLoadUsersOnSearch } from '../../../../../hooks/asset.hooks'
import {
	useUpdateMentionUnreads,
	useMentionsSendMail,
} from '../../../../../hooks/shared.hooks'
import OutlookPasswordSetup from '../outllookPassword'
import './styles.scss'
import { AlertBox } from './../../../../../components/AlertBox/index'
import { toConvertSentenceCase } from '../../../../../utils/form.util'
import { useLanguageContext } from '../../../../../context/locale.context'
import {
	dataLayerTagManager,
	eventLabelTrack,
	GA_CATEGORY_WORKSPACE_PANEL,
	sectionDetailedTrack,
} from './../../../../repository/repo.utils'
import { MdCheck, MdClose } from 'react-icons/md'
import { pushFileToS3 } from '../../../../../utils/aws.util'
import SVGIcon from '../../../../../assets/svgIcons'
import { ParticipantDrawer } from '../../../../../components/globalComponents/participantDrawer'
import ButtonCTA from './../../../../../components/globalComponents/button/index'

const TimelineBottomBar = ({
	activity,
	openAttachment,
	onOpenParticipantView,
	isReplyOn,
	timelineReplyData,
	replyData,
	onOpenSendEmail,
	fromExternal = false,
	fileList,
	setfileList,
	completedList,
	setcompletedList,
	removeFile,
	fileAccessTyp,
	onClose,
	isMobileView,
}) => {
	const { mutate } = useAddTimelineUpdate()
	const {
		state: { timelineFilter },
		dispatch,
	} = useSharedContext()

	const { mutate: mutateLoadAssets } = useLoadUsersOnSearch()
	const { mutate: mutateUnreadUpdate } = useUpdateMentionUnreads()
	const { mutate: mutateSendMentionEmail } = useMentionsSendMail()
	const { mutate: inviteMutate } = useInviteParticipant()

	const [searchText, setSearchText] = useState('')
	const [users, setUsers] = useState([])
	const [selectedUsers, setSelectedUsers] = useState([])
	const [selectedParticipant, setSelectedParticipant] = useState([])
	const [isLoading, setisLoading] = useState(false)
	const [uploadingFile, setuploadingFile] = useState(null)
	const [alertMessage, setAlertMessage] = useState('')
	const [participentError, setparticipentError] = useState('')
	const submitBtnRef = useRef(null)
	const {
		isOpen: isConfirm,
		onOpen,
		onToggle: onToggleConfirm,
	} = useDisclosure()
	const {
		isOpen: addParticipantFormIsOpen,
		onOpen: addParticipantOnOpen,
		onClose: addParticipantOnClose,
	} = useDisclosure()
	const {
		isOpen: isfilter,
		onOpen: filterOpen,
		onClose: isfilterClose,
	} = useDisclosure()
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const {
		asset_id,
		operating_asset_first_name,
		organization_flag_enable_attachment_access_control,
	} = authData
	const {
		activity_id,
		activity_type_id,
		activity_type_category_id,
		activity_title,
		asset_email_id,
	} = activity || {}
	const {
		handleSubmit,
		formState: { errors },
		control,
		reset,
	} = useForm()

	useEffect(() => {
		setSearchText('')
	}, [activity])

	const {
		timeline_transaction_id,
		timeline_stream_type_id,
		data_form_transaction_id,
		data_entity_inline,
		operating_asset_first_name: msg_asset_first_name,
		log_asset_id,
		log_asset_first_name,
		log_asset_last_name,
		title,
	} = !!replyData ? replyData : {}

	const onComment = async () => {
		if (!searchText || !searchText.trim()) {
			alert('Comment should not be empty')
			return
		}
		eventLabelTrack({
			categoryId: 0,
			actionId: 4,
			label: `Send Message`,
		})
		dataLayerTagManager('button_click', {
			viewName: 'File Timeline',
			buttonName: 'Send',
		})
		let comment = toConvertSentenceCase(searchText)
		setSearchText('')
		let { is_password_set, organization_flag_email_integration_enabled } =
			authData
		let msgReplyParams = {
			timeline_transaction_id: timeline_transaction_id,
			timeline_transaction_stream_type_id: timeline_stream_type_id,
			form_transaction_id: data_form_transaction_id,
			content: title, //inlineData.mail_body,
			log_asset_id,
			log_asset_first_name: msg_asset_first_name,
			log_asset_last_name,
		}
		const urlPromises = fileList.map(async file => {
			setuploadingFile(file)
			const blob = file.slice(0, file.size, file.type)
			const newFile = new File([blob], file.name.replace(/ /gi, '-'), {
				type: blob.type,
			})
			let result = await pushFileToS3(newFile)
			setuploadingFile(null)
			setcompletedList([...completedList, file.name])

			return result
		})
		const urls = await Promise.all(urlPromises).then(urldata => urldata)

		let payload = {
			content: sanitizeContent(comment),
			subject: 'Note - ' + formatNoteUpdateDate(),
			mail_body: sanitizeContent(comment),
			attachments: urls,
			activity_reference: [{ activity_title: '', activity_id: '' }],
			asset_reference: [],
			form_approval_field_reference: [],
			is_reply: !!isReplyOn ? 1 : 0,
			replying_to: !!isReplyOn ? msgReplyParams : null,
		}
		mutate(
			{
				operating_asset_first_name,
				activity_id,
				activity_type_category_id,
				activity_type_id,
				// data_entity_inline: JSON.stringify(payload),
				activity_timeline_collection: JSON.stringify(payload),
			},
			{
				onSuccess: async data => {
					setSearchText('')
					dispatch({
						type: sharedConst.REFRESH_TIMELINE,
					})
					timelineReplyData(null)
				},
			}
		)
		mutateUnreadUpdate(
			{
				...prepareMentionUnreadParams(),
			},
			{
				onSuccess: async data => {},
				onError: async err => {},
			}
		)
		if (!!selectedUsers && selectedUsers?.length) {
			inviteMutate(
				{
					activity_id,
					activity_type_category_id: activity_type_category_id,
					activity_type_id,
					participants: selectedUsers.map(u => ({
						...u,
						asset_category_id: 1,
						access_role_id: 1,
					})),
				},
				{
					onSuccess: async data => {
						setSelectedUsers([])
					},
				}
			)
		}
		// TODO: 1 : outlook
		// TODO: 2 : standard : no need to check password
		// If no user selected, sendMentionMail is not being called
		if (!!selectedUsers.length && validateSendMail()) {
			mutateSendMentionEmail(
				{
					...sendMentionsMailParams(),
				},
				{
					onSuccess: async data => {
						setSelectedUsers([])
					},
					onError: async err => {
						setSelectedUsers([])
						console.log('err', err)
					},
				}
			)
		} else {
			setSelectedUsers([])
		}
	}
	const onCommentfile = ({ url }) => {
		let comment = toConvertSentenceCase(searchText)
		let payload = {
			content: sanitizeContent(comment),
			subject: url,
			mail_body: url,
			attachments: [url],
			activity_reference: [],
			asset_reference: [],
			form_approval_field_reference: [],
			is_reply: 0,
			flag_attachment_access_restricted: !!fileAccessTyp
				? organization_flag_enable_attachment_access_control
				: 0,
			doc_access_participants: [
				...selectedParticipant.map(p => ({
					asset_id: p.asset_id,
					asset_name: p.operating_asset_first_name,
				})),
				organization_flag_enable_attachment_access_control === 1 && {
					asset_id: asset_id,
					asset_name: operating_asset_first_name,
				},
			],
		}
		mutate({
			operating_asset_first_name,
			activity_id,
			activity_type_category_id,
			activity_type_id,
			// data_entity_inline: JSON.stringify(payload),
			activity_timeline_collection: JSON.stringify(payload),
		})
	}
	const onUpload = async () => {
		// if (
		// 	(!searchText || !searchText.trim()) &&
		// 	fileList.length <= 1 &&
		// 	fileAccessTyp !== 'enableAccess'
		// ) {
		// 	alert('Comment should not be empty')
		// 	return
		// }

		setparticipentError('')
		if (!!fileAccessTyp && selectedParticipant.length === 0) {
			addParticipantOnOpen()
			setparticipentError('required')
			return
		}

		if (fileList.length >= 1) {
			eventLabelTrack({
				categoryId: 0,
				actionId: 5,
				label: `Uploading Files in Timeline`,
			})

			setisLoading(true)
			const urlPromises = fileList.map(async file => {
				setuploadingFile(file)
				const blob = file.slice(0, file.size, file.type)
				const newFile = new File([blob], file.name.replace(/ /gi, '-'), {
					type: blob.type,
				})
				let result = await pushFileToS3(newFile)
				setuploadingFile(null)
				setcompletedList([...completedList, file.name])

				return result
			})
			const urls = await Promise.all(urlPromises)
			const commentPs = urls.map(async item => await onCommentfile(item))
			await Promise.all(commentPs)
			setisLoading(false)
			setfileList([])
			setSearchText('')
			setSelectedParticipant([])
			setTimeout(() => {
				dispatch({
					type: sharedConst.REFRESH_TIMELINE,
				})
				onClose()
			}, 500)
		} else {
			onComment()
		}
	}
	const validateSendMail = () => {
		if (authData.organization_flag_email_integration_enabled === 1) {
			const { valid, msg } = validateEmailUsernamePassword(authData)
			if (valid) return true
			else {
				setAlertMessage(msg)
				onOpen()
				return false
			}
		} else {
			return true
		}
	}

	const prepareMentionUnreadParams = () => {
		return {
			assets_referenced: selectedUsers
				? selectedUsers.map(user => user.asset_id)
				: [],
			activity_id: activity_id,
		}
	}

	const sendMentionsMailParams = () => {
		return {
			workflow_title: activity_title,
			workflow_update: sanitizeContent(searchText),
			datetime_log: getCurrentDateUTC(),
			mentioned_assets: selectedUsers
				? selectedUsers.map(user => user.asset_id)
				: [],
			mentioned_by_asset_name: operating_asset_first_name,
			workflow_activity_id: activity_id,
			activity_type_id: activity_type_id,
			activity_type_category_id: activity_type_category_id,
			email_sender: authData.asset_email_id,
			is_version_v1: 1,
		}
	}

	const handleText = e => {
		setSearchText(e.target.value)
		if (e.target.value === '') {
			setSelectedUsers([])
		}
	}

	const loadUsers = (query, callback) => {
		mutateLoadAssets(
			{
				params: {
					limit_value: 100,
					start_from: 0,
					asset_type_category_id: 3,
					search_string: query.toLowerCase(),
					is_createdesk: 1,
				},
			},
			{
				onSuccess: async data => {
					setUsers(data)
					let displayList = data.map(emp => {
						return {
							display: `${emp.operating_asset_first_name} - ${
								authData.organization_flag_mention_setting === 1
									? emp.asset_type_name
									: emp.account_name
							}`,
							id: emp.asset_id,
						}
					})
					callback(displayList)
				},
				onError: async err => {
					console.log('err', err)
				},
			}
		)
	}

	const checkUserId = id => {
		const user = !!users && users.find(emp => emp.asset_id === id)
		return user
	}

	const handleComments = id => {
		if (selectedUsers.length > 0) {
			if (!selectedUsers.some(item => item.asset_id === id)) {
				let getUser = checkUserId(id)
				if (!!getUser) {
					setSelectedUsers([...selectedUsers, getUser])
				}
			}
		} else {
			let getUser = checkUserId(id)
			if (!!getUser) {
				setSelectedUsers([getUser])
			}
		}
	}
	const optionListFil = timelineOptions(locale)
	const fileSizeFormatted = size => {
		if (!size || size < 1000) {
			return `${size} Bytes`
		} else if (size < 1000000) {
			return `${Math.floor(size / 1000)}KB`
		} else {
			return `${Math.floor(size / 1000000)}MB`
		}
	}
	return (
		<>
			{fileAccessTyp === 'enableAccess' && (
				<ParticipantDrawer
					headerText={'Select participants who can access attachments'}
					isOpen={addParticipantFormIsOpen}
					onClose={addParticipantOnClose}
					selectedParticipant={selectedParticipant}
					setSelectedParticipant={setSelectedParticipant}
					onSubmit={addParticipantOnClose}
				/>
			)}
			<Box
				display={'flex'}
				w='100%'
				flexDirection={'column'}
				h='100%'
				bg='#F1F3F9'
			>
				<Box
					w='100%'
					mx='auto'
					display={'flex'}
					flexDirection={'row'}
					// h={fileList?.length > 0 ? '30px' : '0px'}
					zIndex='1'
					bg='#F1F3F9'
					mt='-4'
					mb='0.5'
				>
					{fileList?.length > 0 && (
						<>
							<Box display='flex' alignItems='center' bg='#FFFFFF'>
								<Text px='2'>{locale['Attachments']}</Text>
							</Box>
							{fileAccessTyp === 'enableAccess' && fileList.length >= 1 && (
								<Box bg='#FFFFFF' ml='0.5' position='relative' w='3rem'>
									<Center mt='3px' cursor={'pointer'}>
										<SVGIcon
											iconName='participantSvg'
											svgProps={{
												width: '28',
												height: '28',
												viewBox: '0 0 35 35',
											}}
											onClick={() => addParticipantOnOpen()}
										/>
									</Center>
									<Badge
										position='absolute'
										top='1px'
										right='5px'
										borderRadius='full'
										size='md'
										background='yellow.600'
									>
										<Text fontSize='10px' color='black'>
											{selectedParticipant?.length}
										</Text>
									</Badge>
								</Box>
							)}

							<Box
								ml='0.5'
								w={'90%'}
								// mt='-1'
								minH='30px'
								display='flex'
								flexDirection='row'
								bg='#FFFFFF'
								overflowY={'hidden'}
								overflowX='auto'
							>
								{(fileList || []).map((file, index) => {
									const { name, size } = file
									return (
										<Box key={index} ml='2'>
											<Flex>
												<Center position='relative' alignSelf='center'>
													{/* <Box boxShadow='md' bg='white' p={1}>
												<Text fontSize='12px' textTransform='uppercase'>
													{name.split('.').pop()}
												</Text>
												</Box> */}
													<IconButton
														color='brand.700'
														h='24px'
														w='24px'
														bg='#FFFFFF'
														_hover={{
															bg: '',
														}}
														icon={<Icon as={MdFilePresent} w='24px' h='24px' />}
													/>
													{/* <MdFilePresent w='24px' h='24px' color='brand.700' /> */}
												</Center>
												<Box flex={1} mt='1' width={'80px'}>
													<Text
														color='#000000'
														fontSize='12px'
														wordBreak='break-all'
														fontWeight='400'
														textOverflow='ellipsis'
														overflow='hidden'
														whiteSpace='nowrap'
													>
														{name}
													</Text>
													<Text
														color='gray.400'
														fontSize='10px'
														fontWeight='400'
													>
														{fileSizeFormatted(size)}
													</Text>
												</Box>
												<Center position='relative' alignSelf='center'>
													<IconButton
														size='sm'
														h='24px'
														w='24px'
														color='brand.700'
														bg='#FFFFFF'
														// _focus={{
														// 	bg: 'secondary',
														// }}
														_hover={{
															bg: '',
														}}
														icon={
															<Icon
																as={
																	completedList.includes(name)
																		? MdCheck
																		: MdClose
																}
																w={6}
																h={6}
															/>
														}
														onClick={() => {
															sectionDetailedTrack({
																category: GA_CATEGORY_WORKSPACE_PANEL,
																action: 'Timeline Attachment',
																label: 'Remove File',
															})
															if (completedList.includes(name)) {
															} else removeFile(file)
															// completedList.includes(name)
															// ? () => null
															// : () => removeFile(file)
														}}
													/>
												</Center>
											</Flex>
											{/* </ListItem> */}
											{/* <Divider border='1px' borderColor='white' mt={2} /> */}
										</Box>
									)
								})}
							</Box>
						</>
					)}
				</Box>

				<HStack
					// style={{ marginTop: '0' }}
					mt={fileList?.length > 0 ? '0px' : '14px'}
					w='100%'
					// spacing={2}
					alignItems='center'
					h={fileList?.length > 0 ? '50%' : '100%'}
					bg='#FFFFFF'
					border={'1px solid E1E1E1'}
					// mt='7'
				>
					<AlertBox
						isOpen={isConfirm}
						onClose={onToggleConfirm}
						Message={alertMessage}
					/>
					<CustomMenu
						className={`timeline-attachment-message-menu`}
						icon={MdMoreVert}
						color='brand.800'
						borderRadius='md'
						boxShadow={0}
						aria-label='More'
						size='sm'
						top='0px'
						right='0px'
						optionList={[
							...(!fromExternal
								? [
										{
											label: locale['Send Email'],
											isMenu: true,
											icon: (
												<Icon
													as={BiMailSend}
													w={5}
													h={5}
													color='brand.700'
													display='inherit'
												/>
											),
											onClick: e => {
												onOpenSendEmail()
											},
											optionListProps: { color: 'brand.700' },
										},
								  ]
								: []),
							{
								label: locale['File Upload'],
								isMenu: true,
								icon: (
									<Icon
										as={ImAttachment}
										w={4}
										h={4}
										color='brand.700'
										display='inherit'
									/>
								),
								onClick: e => {
									openAttachment('')
								},
								optionListProps: { color: 'brand.700' },
							},
							...(organization_flag_enable_attachment_access_control > 0 &&
							!fromExternal
								? [
										{
											label: locale['Access controlled attachments'],
											isMenu: true,
											icon: (
												<Icon
													as={BsFillFileEarmarkLockFill}
													w={4}
													h={4}
													color='brand.700'
													display='inherit'
												/>
											),
											onClick: e => {
												openAttachment('enableAccess')
											},
											optionListProps: { color: 'brand.700' },
										},
								  ]
								: []),
						]}
						selected={{}}
					/>

					<form
						onSubmit={handleSubmit(onUpload)}
						style={{
							flex: 1,
							display: 'flex',
							justifyContent: 'space-around',
							alignItems: 'center',
							minWidth: '0',
							wordBreak: 'break-all',
						}}
					>
						<KeyboardEventHandler
							style={{
								flex: '1',
								marginRight: '5px',
							}}
							handleKeys={['alt+enter', 'alt+return']}
							onKeyEvent={(key, e) => {
								if (submitBtnRef.current) {
									submitBtnRef.current.click()
								}
							}}
						>
							<FormControl id='message' flex={1} mr={2} className='message-box'>
								{!!isReplyOn && (
									<Box className='reply-box'>
										<Box className='reply-content'>
											<IoMdClose
												onClick={() => {
													sectionDetailedTrack({
														category: GA_CATEGORY_WORKSPACE_PANEL,
														action: 'Timeline Bottom Panel',
														label: 'Close',
													})
													timelineReplyData(null)
												}}
											/>
											<Text as='small'>
												<Text fontWeight='bold'>{msg_asset_first_name}</Text>
											</Text>
											<Text>{title}</Text>
										</Box>
									</Box>
								)}
								<MentionsInput
									onChange={handleText}
									value={searchText}
									// onKeyUp={handleKeyDown}
									allowSpaceInQuery={true}
									className='mentionWrapper'
									placeholder={locale['Enter message here']}
									disabled={fileList.length <= 1 ? false : true}
								>
									<Mention
										trigger='@'
										data={loadUsers}
										onAdd={handleComments}
										renderSuggestion={(
											id,
											display,
											search,
											highlightedDisplay
										) => {
											return (
												<Text as='span' flex={1} fontSize='sm' color='black'>
													{search}
												</Text>
											)
										}}
										displayTransform={(id, display) => {
											return `@${display}`
										}}
										appendSpaceOnAdd={true}
									/>
								</MentionsInput>
								{/* <Controller
              render={() => {
                return (

                );
              }}
              name="comment"
              control={control}
              defaultValue=""
              rules={{
                required: {value: true,message: 'Comment is required!'},
              }}
            /> */}
							</FormControl>
						</KeyboardEventHandler>
						{/* <ButtonCTA
							type='submit'
							ref={submitBtnRef}
							borderRadius='full'
							bg='brand.700'
							aria-label='Search database'
							leftIcon={<Icon as={BiSend} color='white' bg='white' />}
							_hover={{
								background: 'brand.700',
							}}
						>
							{!isMobileView ? locale['Send'] : ''}
						</ButtonCTA> */}
						<IconButton
							type='submit'
							ref={submitBtnRef}
							bg='brand.700'
							_hover={{
								background: 'brand.700',
							}}
							borderRadius='full'
							aria-label='Search database'
							fontSize='20px'
							icon={<BiSend color='white' w='1rem' h='1rem' />}
						/>
					</form>

					<Tooltip hasArrow label={locale['Timeline Filters']}>
						<Drawer isOpen={false} placement='right' onClose={isfilterClose}>
							<DrawerOverlay />
							<DrawerContent>
								<DrawerCloseButton />
								<DrawerHeader>
									<Text size='16px' fontWeight={'500'}>
										{'Timeline Content Filter By'}
									</Text>
								</DrawerHeader>

								<DrawerBody>
									<span>
										{optionListFil.length > 0 &&
											optionListFil.map(item => (
												<Box
													color={'brand.700'}
													p='0.7rem'
													borderBottom={'1px solid #EDEDED'}
													fontSize='16px'
													fontWeight={500}
													fontStyle={'normal'}
													onClick={() => {
														dataLayerTagManager({
															viewName: 'File Timeline',
															buttonName: 'Filter',
														})
														dispatch({
															type: sharedConst.TIME_LINE_FILTER,
															filterValue: item,
														})
													}}
												>
													<Flex justifyContent={'space-between'}>
														<Text>{item?.label}</Text>
														{timelineFilter?.label === item?.label && (
															<IoMdCheckmark></IoMdCheckmark>
														)}
													</Flex>
												</Box>
											))}
										{/* <CustomMenu
									optionList={timelineOptions(locale)}
									selected={timelineFilter}
									onSelect={item => {
										dataLayerTagManager('button_click', {
											viewName: 'File Timeline',
											buttonName: 'Filter',
										})
										dispatch({
											type: sharedConst.TIME_LINE_FILTER,
											filterValue: item,
										})
									}}
									icon={MdFilterList}
								/> */}
									</span>
								</DrawerBody>
							</DrawerContent>
						</Drawer>
					</Tooltip>

					{/* {!fromExternal && (
        <Tooltip hasArrow label={locale['Add participant']}>
          <IconButton
            bg="white"
            borderRadius="md"
            boxShadow="md"
            aria-label="Add participant"
            size="md"
            _focus={{
              bg: 'secondary',
            }}
            _hover={{
              bg: 'secondary',
            }}
            icon={<Icon as={MdPersonAdd} w={5} h={5} />}
            onClick={() => {
              eventLabelTrack({
                categoryId: 0,
                actionId: 6,
                label: 'Open Participant Modal For An Activity',
              })
              dataLayerTagManager('button_click', {
                viewName: 'File Timeline',
                buttonName: 'Add Participant',
              })
              onOpenParticipantView()
            }}
          />
        </Tooltip>
      )} */}
				</HStack>
			</Box>
		</>
	)
}

export default TimelineBottomBar
